import { Injectable } from '@angular/core';
import { MapsAPILoader } from '@agm/core';

declare var google: any;

@Injectable({
  providedIn: 'root'
})
export class GeocodeService {
  private geocoder: any;

  constructor(private mapLoader: MapsAPILoader) { }

  private async loadMap() : Promise<void> {
    if(!this.geocoder) {
      return this.mapLoader.load().then(() => {
        this.geocoder = new google.maps.Geocoder();
      });
    } else {
      return new Promise<void>((resolve, reject) => {
        resolve();
      });
    }
  }

  geocodeAddress(location: string, callback: Function) {
    this.loadMap().then(() => {
      this.geocoder.geocode({'address': location}, (results, status) => {
        if (status == google.maps.GeocoderStatus.OK) {
          callback(results[0].geometry.location.lat(), results[0].geometry.location.lng());
        }
      });
    });
  }
}
